import { render, staticRenderFns } from "./ShowEchange.vue?vue&type=template&id=22530dbf&scoped=true&"
import script from "./ShowEchange.vue?vue&type=script&lang=js&"
export * from "./ShowEchange.vue?vue&type=script&lang=js&"
import style0 from "./ShowEchange.vue?vue&type=style&index=0&id=22530dbf&lang=scss&scoped=true&"
import style1 from "./ShowEchange.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22530dbf",
  null
  
)

export default component.exports